/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 8/27/13
 * Time: 5:40 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var Button = require("ui/button/Button");

    /*
     This model will hold the data of the tab UI state
     Selected or not, checked or not
     */

    var TabModel;
    TabModel = BaseModel.extend({
        defaults: {
            id  : null,
            name: "",
            className: "",
            tooltip:  "",
            hasCheckbox : false,   //show checkbox on the button
            checkBoxValue: true,   //the checkbox value
            checkboxEnabled: true,  //Is the checkbox enabled or disabled
            tabClickable: true, // Is the tab itself is clickable and can be selected through the ui
            hasContent: false,  //does the tab contain content ( available for permutation B)
            align: false,
            isButton: false, //tab is button
            isAll: false, //all style tab
            btnPermutation: Button.PERMUTATION.BTN,
            btnState: Button.STATES.ENABLED,
            dataAttributes: {}
        },
        getDataAttributes:function () {
            return this.get("dataAttributes");
        }
    });

    return TabModel;
});
